import { Box } from "@mui/material";
import { StreamFinIcon } from "../../../icons";
import { Grid, Typography } from "../../basics";
import { StyledAssistentButton } from "./styled";
import { IAssistentButtonProps } from "./types";

const AssistentButton = ({ onClick }: IAssistentButtonProps) => (
    <StyledAssistentButton>
        <Grid container onClick={onClick} alignItems="center" wrap="nowrap">
            <Box component="span" className="AssistentButton-badge">
                <Box component="span" className="AssistentButton-wave">
                    <StreamFinIcon />
                </Box>
            </Box>
            <Typography variant="body1" className="AssistentButton-label">Assistente</Typography>
        </Grid>
    </StyledAssistentButton>
);

export { AssistentButton };
